
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/appliance-removal",
      function () {
        return require("private-next-pages/appliance-removal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/appliance-removal"])
      });
    }
  